module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Medium.d62390ab.svg";